import { Checkbox, Popup, Button } from "antd-mobile";
import styled from "styled-components";

const Title = styled.div`
  text-align: center;
  font-size: 17px;
  font-weight: 700;
  padding: 16px;
`;

const Body = styled.div`
  padding: 0 16px 12px;
  font-size: 14px;
  line-height: 22px;
  color: #7f7f7f;
  max-height: 50vh;
  overflow: auto;
`;

const Danger = styled.span`
  color: #df2121;
`;

const Footer = styled.div`
  padding: 12px 16px 28px;
`;

type Props = {
  visible: boolean;
  selected: boolean;
  onSelected: (v: boolean) => void;
  onConfirm: () => void;
  onClose: () => void;
  confirmText?: string;
};

const ProtocolConfirmModal = ({
  visible,
  selected,
  onSelected,
  onConfirm,
  onClose,
  confirmText = "确定下单",
}: Props) => (
  <Popup
    visible={visible}
    onMaskClick={onClose}
    bodyStyle={{ borderTopLeftRadius: 16, borderTopRightRadius: 16 }}
  >
    <Title>交易须知</Title>
    <Body>
      <div>
        1、恶意下单传假图，平台将予<Danger>封号冻结资金</Danger>；
      </div>
      <div>
        2、卖家同意后，<Danger>15分钟</Danger>内完成打款并<Danger>提交</Danger>；
      </div>
      <div>
        3、下单无故取消订单，将<Danger>扣除一定的信用分</Danger>；
      </div>
      <div>
        4、交易期间保持<Danger>手机畅通</Danger>，并留意短信提醒；
      </div>
      <div>
        5、请<Danger>实名账户</Danger>打款，否则卖家有权拒绝发货；
      </div>
      <div>
        6、<Danger>请确认本次购买的喜鹊币单价。</Danger>
      </div>
    </Body>
    <Footer>
      <Checkbox
        checked={selected}
        onChange={onSelected}
        style={{ marginBottom: 12, fontSize: 14 }}
      >
        我已阅读并同意以上交易须知
      </Checkbox>
      <Button
        color="primary"
        block
        disabled={!selected}
        onClick={() => {
          onConfirm();
          onClose();
        }}
      >
        {confirmText}
      </Button>
    </Footer>
  </Popup>
);

export default ProtocolConfirmModal;
